import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconMedal = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    viewBox="0 0 26 26"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.95}
      d="M11.453 6.64c-1.969.329-3.75 1.22-5.11 2.532l-5.25-7.453C.767 1.203 1.142.5 1.75.5h5.625c.234 0 .516.14.61.375l3.468 5.766ZM13 8c4.547 0 8.25 3.703 8.25 8.25A8.232 8.232 0 0 1 13 24.5a8.203 8.203 0 0 1-8.25-8.25A8.232 8.232 0 0 1 13 8Zm4.313 7.406c.328-.328.14-.89-.282-.937l-2.484-.375-1.078-2.203c-.094-.188-.281-.282-.516-.282a.515.515 0 0 0-.469.282l-1.078 2.203-2.484.375c-.422.047-.61.61-.281.937l1.78 1.735L10 19.578c-.094.422.375.75.797.563l2.156-1.172 2.203 1.172c.422.234.89-.141.797-.563l-.422-2.437 1.781-1.735ZM24.203.5c.61 0 .985.703.656 1.172l-5.25 7.453C18.25 7.812 16.47 6.922 14.5 6.594L17.922.875A.808.808 0 0 1 18.578.5h5.625Z"
    />
  </svg>
));
export default SvgIconMedal;
